import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CheckboxEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { CheckboxList } from 'site-modules/lease-deals/components/filters/ui/primitives/checkbox-list/checkbox-list';
import { CheckboxItem } from 'site-modules/lease-deals/components/filters/ui/primitives/checkbox-item/checkbox-item';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { LEASE_DEALS_FILTERS } from 'site-modules/lease-deals/constants/lease-deals-constants';

export function TrackedCheckboxControl({ options, dataKey, selectedValues = [], onChange, classNames = 'px-1' }) {
  const handleChange = useCallback(
    (newValues, value, checked) => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_TOOL_SELECT,
          subaction_name: checked ? 'apply_filter' : 'remove_filter',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          creative_id: LEASE_DEALS_FILTERS,
          value: `${dataKey}~${value}`,
        },
      });

      onChange(newValues);
    },
    [dataKey, onChange]
  );

  return (
    <CheckboxList
      options={options}
      selectedValues={selectedValues}
      onChange={handleChange}
      classNames={classNames}
      checkboxComponent={CheckboxItem}
    />
  );
}

TrackedCheckboxControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: CheckboxEntity.isRequired,
  dataKey: PropTypes.string.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  classNames: PropTypes.string,
};
